import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { LogOut, Mail } from "lucide-react";
import "./emailConfirmation.css";

const EmailConfirmationBlocker = ({ user, onLogout }) => {
  const [resendStatus, setResendStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResendConfirmation = async () => {
    if (!user) return;
    setLoading(true);
    setResendStatus("");

    const { error } = await supabase.auth.resend({
      type: "signup",
      email: user.email,
    });

    setLoading(false);
    if (error) {
      setResendStatus(`Erro ao reenviar: ${error.message}`);
    } else {
      setResendStatus(
        "Email de confirmação reenviado com sucesso! Verifique sua caixa de entrada e spam."
      );
    }
  };

  return (
    <div className="email-confirmation-blocker">
      <div className="confirmation-box">
        <Mail size={48} className="icon-mail" />
        <h2>Confirme seu E-mail</h2>
        <p>
          Enviamos um link de confirmação para <strong>{user?.email}</strong>.
        </p>
        <p>
          Por favor, clique no link para ativar sua conta e ter acesso completo
          à plataforma.
        </p>

        <button
          onClick={handleResendConfirmation}
          disabled={loading}
          className="btn-primary"
        >
          {loading ? "Reenviando..." : "Reenviar E-mail de Confirmação"}
        </button>

        {resendStatus && (
          <p className="resend-status-message">{resendStatus}</p>
        )}

        <button onClick={onLogout} className="btn-secondary logout-button">
          <LogOut size={16} /> Sair
        </button>
      </div>
    </div>
  );
};

export default EmailConfirmationBlocker;
